import { useTimeFormatStore } from "../store/time-format";
import {
  formatDateTime,
  formatTime,
  getCalendarTimeFormat,
  getHourCycle,
  is24HourFormat,
} from "../util/DateHelper";

// US 922643: component access to the 12/24-hour preference. Subscribing to the
// store re-renders the component when the preference changes; the formatters
// themselves live in util/DateHelper so non-React code shares the same logic.
export default function useTimeFormat() {
  const timeFormat = useTimeFormatStore((state) => state.timeFormat);
  return {
    timeFormat,
    is24Hour: is24HourFormat(timeFormat),
    hourCycle: getHourCycle(timeFormat),
    calendarTimeFormat: getCalendarTimeFormat(timeFormat),
    formatTime,
    formatDateTime,
  };
}
